import { useEffect, useState } from 'react'
import { adminService } from 'core/services/adminService'
import { TaskItem } from './task-item'
import { TaskEdit } from './task-edit'

import c from './assets/sass/tasks-list.module.scss'

export const TasksList = () => {
    const [tasks, setTasks] = useState([])
    const [loading, setLoading] = useState(true)
    const [editing, setEditing] = useState(null)
    const [creating, setCreating] = useState(false)

    useEffect(() => {
        loadTasks()
    }, [])

    const loadTasks = async () => {
        try {
            const data = await adminService.getTasks()
            setTasks(data.tasks)
        } catch (error) {
            console.error('Failed to load tasks:', error)
        } finally {
            setLoading(false)
        }
    }

    if (loading) return <div className={c.loading}>Загрузка...</div>

    if (editing || creating) {
        return (
            <TaskEdit
                task={editing}
                onSave={() => {
                    loadTasks()
                    setEditing(null)
                    setCreating(false)
                }}
                onCancel={() => {
                    setEditing(null)
                    setCreating(false)
                }}
            />
        )
    }

    return (
        <div className={c.component}>
            <button className={c.createBtn} onClick={() => setCreating(true)}>
                + Создать задание
            </button>
            <div className={c.list}>
                {tasks.map((task) => (
                    <TaskItem
                        key={task.id}
                        task={task}
                        onEdit={() => setEditing(task)}
                        onUpdate={loadTasks}
                    />
                ))}
            </div>
        </div>
    )
}
